import { useEffect, useRef, useState } from "react";
import { ChevronDown, Search, X } from "lucide-react";

const label = (e) => e.motor_name ? `${e.motor_name} - ${e.part_code}` : `${e.part_code}${e.ecm_id ? " - " + e.ecm_id : ""}`;

export const EcuLibDropdown = ({ items, onPick, preset }) => {
  const [open, setOpen] = useState(false);
  const [searchOn, setSearchOn] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);
  useEffect(() => {
    const h = (ev) => { if (ref.current && !ref.current.contains(ev.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  useEffect(() => {
    if (preset?.q) { setSearchOn(true); setQ(preset.q); setOpen(true); }
  }, [preset]);
  const s = q.trim().toLowerCase();
  const list = items.filter((e) => !s || label(e).toLowerCase().includes(s))
    .sort((a, b) => (!a.motor_name - !b.motor_name) || label(a).localeCompare(label(b), undefined, { numeric: true }));
  const toggleSearch = () => { setSearchOn((v) => !v); setQ(""); setOpen(true); };

  return (
    <div ref={ref} data-testid="mapedit-library-list" className="relative mb-2 w-full">
      <div className="flex items-center gap-2">
        {searchOn ? (
          <input autoFocus data-testid="mapedit-library-search" value={q} onChange={(e) => { setQ(e.target.value); setOpen(true); }}
            placeholder="Search ECU code…" className="flex-1 min-w-0 h-9 px-3 rounded border border-[#4b505b] bg-[#121824] text-slate-100 text-sm focus:outline-none focus:ring-1 focus:ring-red-500" />
        ) : (
          <button data-testid="mapedit-library-toggle" onClick={() => setOpen((v) => !v)}
            className="flex-1 min-w-0 h-9 flex items-center justify-between px-3 rounded border border-[#4b505b] bg-[#121824] text-slate-100 text-sm font-semibold hover:border-red-500 transition-colors">
            <span className="truncate">BASEMAP</span>
            <ChevronDown className={`h-4 w-4 shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
          </button>
        )}
        <button data-testid="mapedit-library-search-btn" onClick={toggleSearch} title="Search ECU code"
          className="h-9 w-9 shrink-0 inline-flex items-center justify-center rounded bg-red-600 hover:bg-red-500 text-white transition-colors">
          {searchOn ? <X className="h-4 w-4" /> : <Search className="h-4 w-4" />}
        </button>
        <span data-testid="mapedit-library-count" className="shrink-0 text-[11px] text-slate-400 font-mono">{s ? `${list.length}/${items.length}` : items.length} kode</span>
      </div>
      {open && (
        <div data-testid="mapedit-library-scroll" className="absolute z-40 left-0 right-0 mt-1 max-h-60 overflow-y-auto overscroll-contain rounded border border-[#4b505b] bg-[#0c1017] shadow-xl [scrollbar-width:thin] [scrollbar-color:#dc2626_#16181d]">
          {list.length === 0 && <div className="px-3 py-2 text-sm text-slate-400">No matching code</div>}
          {list.map((e) => (
            <button key={e.id} data-testid={`mapedit-library-item-${e.id}`} onClick={() => { setOpen(false); onPick(e); }}
              className="w-full px-3 py-1.5 text-left text-sm text-slate-100 hover:bg-red-600 hover:text-white transition-colors truncate">
              {label(e)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
